import { render } from "./TemplateDemandBooking1.vue?vue&type=template&id=5a1babf5"
import script from "./TemplateDemandBooking1.vue?vue&type=script&lang=js"
export * from "./TemplateDemandBooking1.vue?vue&type=script&lang=js"
script.render = render

export default script